export const areFunctionsEqual = (val1: unknown, val2: unknown) =>
    typeof val1 === 'function' && typeof val2 === 'function'
        ? val1.toString() === val2.toString()
        : undefined
